export const STORAGE_KEY = "fitfaction_list_filters";

export function getStoredFilters(listKey) {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return stored[listKey] || {};
  } catch {
    return {};
  }
}

export function saveStoredFilters(listKey, filters) {
  try {
    const stored = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    stored[listKey] = { ...stored[listKey], ...filters };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  } catch {
    // ignore storage errors
  }
}

export function parseIdListParam(value) {
  if (!value) return [];
  return value.split(",").map((id) => id.trim()).filter(Boolean);
}

export function serializeIdList(ids = []) {
  return ids.filter(Boolean).join(",");
}
